/** Features mega menu items — shared between the desktop panel and the mobile accordion. */
export interface FeatureMenuItem {
    id: string
    pillar: string
    titleLine1: string
    titleLine2: string
    description: string
    to: string
    accent: 'list' | 'optimize' | 'syndicate' | 'expand'
}

export const featureMenuItems: FeatureMenuItem[] = [
    {
        id: 'list',
        pillar: 'List',
        titleLine1: 'List',
        titleLine2: 'Quickly',
        description: 'From Shopify catalog to marketplace-ready listings',
        to: '/features/list-quickly',
        accent: 'list',
    },
    {
        id: 'optimize',
        pillar: 'Optimize',
        titleLine1: 'Optimize',
        titleLine2: 'Effortlessly',
        description: 'Images, copy, and fields tuned per marketplace',
        to: '/features/optimize-effortlessly',
        accent: 'optimize',
    },
    {
        id: 'syndicate',
        pillar: 'Syndicate',
        titleLine1: 'Syndicate',
        titleLine2: 'Seamlessly',
        description: 'Price, inventory, and orders — one source',
        to: '/features/syndicate-seamlessly',
        accent: 'syndicate',
    },
    {
        id: 'expand',
        pillar: 'Expand',
        titleLine1: 'Expand',
        titleLine2: 'Limitlessly',
        description: 'Add Nordstrom or Macy\'s without rebuilding the catalog',
        to: '/features/expand-limitlessly',
        accent: 'expand',
    },
]
